
export default Object.freeze({
    PASSWORD_MIN_LENGTH: 8,
    MIN_BIRTH_YEAR: 1900,

    USER_ROLE_ADMIN: 'Admin',
    USER_ROLE_MEMBER: 'Member',
    USER_ROLE_FINANCE: 'Finance',
    USER_ROLE_SUPPORT: 'Support',

    // Dependent Status
    DEPENDENT_STATUS_PENDING: 'PENDING',
    DEPENDENT_STATUS_NEW: 'NEW',
    DEPENDENT_STATUS_APPROVED: 'APPROVED',
    DEPENDENT_STATUS_DIVORCED: 'DIVORCED',
    DEPENDENT_STATUS_ADMIN_REVIEW: 'ADMIN_REVIEW',
    DEPENDENT_STATUS_DECEASED: 'DECEASED',
    DEPENDENT_STATUS_REJECTED: 'REJECTED',
    DEPENDENT_STATUS_DELETED: 'DELETED',

    // Claim Status
    CLAIM_STATUS_NEW: 'NEW',
    CLAIM_STATUS_VERIFIED: 'VERIFIED',
    CLAIM_STATUS_PAID: 'PAID',
    CLAIM_STATUS_ADMIN_REVIEW: 'ADMIN_REVIEW',
    CLAIM_STATUS_REJECTED: 'REJECTED',

    // Invoice Status
    INVOICE_STATUS_OPEN: 'OPEN',
    INVOICE_STATUS_PAID: 'PAID',
    INVOICE_STATUS_VOID: 'VOID',
    INVOICE_STATUS_DRAFT: 'DRAFT',
    INVOICE_STATUS_OVERDUE: 'OVERDUE',

    // Payment Status
    PAYMENT_STATUS_NEW: 'NEW',
    PAYMENT_STATUS_VERIFIED: 'VERIFIED',
    PAYMENT_STATUS_VOID: 'VOID',
    PAYMENT_STATUS_ADMIN_REVIEW: 'ADMIN_REVIEW',
    PAYMENT_STATUS_REJECTED: 'REJECTED',

    // Payment Methods
    PAYMENT_METHOD_BANK_DEPOSIT: 'Wells Fargo Bank Deposit',
    PAYMENT_METHOD_ZELLE: 'Zelle',
    PAYMENT_METHOD_BANK_TRANSFER_WF: 'Wells Fargo Bank Transfer',
    PAYMENT_METHOD_CHECK: 'Check',
    PAYMENT_METHOD_BANK_TRANSFER_NON_WF: 'Non-Wells Fargo Bank Transfer',

    // Stripe Status
    STRIPE_STATUS_SUCCESS: 'success',
    STRIPE_STATUS_CANCELLED: 'cancelled',

    // User membership qualification
    QUALIFICATION_TYPE_KALENJIN: 1,
    QUALIFICATION_TYPE_SPOUSE: 2,
    QUALIFICATION_TYPE_RECOMMENDED: 3,

    getUserStatusMap() {
        return {
            NEW: 'New',
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
            ADMIN_REVIEW: 'Admin Review',
            REJECTED: 'Rejected',
            TERMINATED: 'Terminated'
        }
    },

    getDependentStatusMap() {
        return {
            NEW: 'New',
            PENDING: 'Pending',
            APPROVED: 'Approved',
            DIVORCED: 'Divorced',
            ADMIN_REVIEW: 'Admin Review',
            DECEASED: 'Deceased',
            REJECTED: 'Rejected',
            DELETED: 'Deleted'
        }
    },

    getClaimStatusMap() {
        return {
            NEW: 'Pending',
            VERIFIED: 'Verified',
            PAID: 'Paid',
            ADMIN_REVIEW: 'Admin Review',
            REJECTED: 'Rejected'
        }
    },


    getInvoiceStatusMap() {
        return {
            OPEN: 'Open',
            PAID: 'Paid',
            VOID: 'Void',
            DRAFT: 'Draft',
            OVERDUE: 'Overdue'
        }
    },


    getPaymentStatusMap() {
        return {
            PENDING: 'Pending',
            VERIFIED: 'Verified',
            VOID: 'Void',
            ADMIN_REVIEW: 'Admin Review',
            REJECTED: 'Rejected'
        }
    },

    getPaymentMethodMap() {
        return {
            CREDIT_CARD: 'Credit Card',
            BANK_DEPOSIT: 'Wells Fargo Bank Deposit',
            ZELLE: 'Zelle',
            BANK_TRANSFER_WF: 'Wells Fargo Bank Transfer',
            CHECK: 'Check',
            BANK_TRANSFER_NON_WF: 'Non-Wells Fargo Bank Transfer',
        }
    }
})
